import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sc-expenditure-status-icon-component',
  templateUrl: './expenditure-status-icon.component.html',
  styleUrls: ['./expenditure-status-icon.component.scss']
})
export class ExpenditureStatusIconComponent implements OnInit {
  @Input() public status: number;
  @Input() public tooltip: string;

  constructor() {}

  public ngOnInit() {}
}
